import React from "react";

interface LoadingProps {
  size?: "sm" | "md" | "lg";
  color?: "primary" | "secondary" | "accent";
}

const Loading: React.FC<LoadingProps> = ({ size = "lg", color = "primary" }) => {
  const getSize = () => {
    switch (size) {
      case "sm":
        return "3rem";
      case "md":
        return "5rem";
      case "lg":
        return "7rem";
      default:
        return "7rem";
    }
  };

  const getColor = () => {
    switch (color) {
      case "primary":
        return "#2563eb";
      case "secondary":
        return "#4b5563";
      case "accent":
        return "#9333ea";
      default:
        return "#2563eb";
    }
  };

  const sizeValue = getSize();
  const colorValue = getColor();

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        backdropFilter: "blur(4px)",
        zIndex: "var(--layer-loading)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <div style={{ position: "relative" }}>
          {/* 외부 원 */}
          <div
            style={{
              width: sizeValue,
              height: sizeValue,
              border: "4px solid #e5e7eb",
              borderRadius: "50%",
            }}
          ></div>

          {/* 회전하는 프로그레스 원 */}
          <div
            style={{
              width: sizeValue,
              height: sizeValue,
              border: "4px solid transparent",
              borderTopColor: colorValue,
              borderRadius: "50%",
              position: "absolute",
              top: 0,
              left: 0,
              animation: "spin 1s linear infinite",
            }}
          ></div>

          {/* 중앙 점 */}
          <div
            style={{
              width: sizeValue,
              height: sizeValue,
              borderRadius: "50%",
              position: "absolute",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "0.5rem",
                height: "0.5rem",
                backgroundColor: colorValue,
                borderRadius: "50%",
              }}
            ></div>
          </div>
        </div>
        {/* <div
          style={{
            fontSize: "1.5rem",
            fontWeight: 700,
            color: "#374151",
          }}
        >
          {isClient ? t("component.loading.text") : "로딩중..."}
        </div> */}
      </div>

      <style>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default Loading;
